

// import React from "react";
// import { Link } from "react-router-dom";
// import { motion } from "framer-motion";

// function Verses() {
//   const verses = Array.from({ length: 48 }, (_, i) => ({
//     id: i + 1,
//     title: `श्लोक ${i + 1}`,
//     num: (i + 1).toLocaleString("hi-IN"), // Devanagari numerals
//   }));

//   return (
//     <motion.div
//       initial={{ opacity: 0 }}
//       animate={{ opacity: 1 }}
//       transition={{ duration: 0.8 }}
//       style={{
//         background:
//           "linear-gradient(180deg, #fffaf3 0%, #fff3e1 40%, #fff 100%)",
//         color: "#4b2e05",
//         minHeight: "100vh",
//         padding: "60px 5%",
//         fontFamily: "'Poppins', 'Noto Sans Devanagari', sans-serif",
//         position: "relative",
//         overflow: "hidden",
//       }}
//     >
//       {/* 🌸 Decorative Background Mandala */}
//       <div
//         style={{
//           position: "absolute",
//           top: "-100px",
//           left: "50%",
//           transform: "translateX(-50%)",
//           width: "500px",
//           height: "500px",
//           background:
//             "radial-gradient(circle, rgba(255,220,160,0.25), transparent 70%)",
//           borderRadius: "50%",
//           zIndex: 0,
//           filter: "blur(20px)",
//         }}
//       />

//       {/* 🕉️ Page Header */}
//       <motion.div
//         style={{
//           textAlign: "center",
//           marginBottom: "40px",
//           position: "relative",
//           zIndex: 1,
//         }}
//         initial={{ opacity: 0, y: -30 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.8 }}
//       >
//         <h2
//           style={{
//             fontSize: "2.8rem",
//             fontWeight: "800",
//             color: "transparent",
//             backgroundImage:
//               "linear-gradient(90deg, #a86a00, #e0a341, #ffcd73)",
//             backgroundClip: "text",
//             WebkitBackgroundClip: "text",
//             textShadow: "0 2px 10px rgba(255,220,150,0.3)",
//           }}
//         >
//           Explore the 48 Shlokas of Bhaktamar Stotra
//         </h2>

//         <motion.div
//           initial={{ scaleX: 0 }}
//           animate={{ scaleX: 1 }}
//           transition={{ duration: 1 }}
//           style={{
//             width: "150px",
//             height: "4px",
//             background:
//               "linear-gradient(90deg, #b66b00, #ffb347, #ffd89b)",
//             margin: "15px auto",
//             borderRadius: "4px",
//           }}
//         />

//         <p
//           style={{
//             fontSize: "1.15rem",
//             color: "#5a3a0e",
//             maxWidth: "800px",
//             margin: "0 auto",
//             lineHeight: "1.8",
//           }}
//         >
//           Each Shloka reveals divine wisdom and healing vibrations.  
//           Tap any verse below to open it in detail.
//         </p>
//       </motion.div>

//       {/* 📜 Shloka Cards Grid */}
//       <div
//         style={{
//           display: "grid",
//           gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
//           gap: "30px",
//           justifyItems: "center",
//           alignItems: "stretch",
//           paddingBottom: "100px",
//           zIndex: 1,
//           position: "relative",
//         }}
//       >
//         {verses.map((verse, i) => (
//           <motion.div
//             key={verse.id}
//             initial={{ opacity: 0, y: 30 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             transition={{ duration: 0.4, delay: i * 0.03 }}
//             whileHover={{
//               scale: 1.05,
//               boxShadow: "0 10px 25px rgba(255,190,120,0.4)",
//               background:
//                 "linear-gradient(145deg, #fff2da, #ffe7c2, #fffaf3)",
//             }}
//             style={{
//               position: "relative",
//               background:
//                 "linear-gradient(145deg, #fffaf2, #fff3e1, #ffefc7)",
//               borderRadius: "20px",
//               padding: "28px 20px 30px",
//               width: "100%",
//               boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
//               border: "1px solid rgba(255,200,150,0.5)",
//               textAlign: "center",
//               transition: "all 0.4s ease",
//             }}
//           >
//             {/* 🔘 Circular Shloka Number */}
//             <div
//               style={{
//                 position: "absolute",
//                 top: "-15px",
//                 left: "-15px",
//                 width: "45px",
//                 height: "45px",
//                 borderRadius: "50%",
//                 background:
//                   "linear-gradient(135deg, #b66b00, #ffb347, #ffd89b)",
//                 color: "#fff",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 fontWeight: "700",
//                 fontSize: "1.1rem",
//                 boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
//               }}
//             >
//               {verse.num}
//             </div>

//             <h3
//               style={{
//                 fontSize: "1.5rem",
//                 fontWeight: "700",
//                 color: "#7a4200",
//                 marginBottom: "10px",
//               }}
//             >
//               {verse.title}
//             </h3>
//             <p
//               style={{
//                 fontSize: "1rem",
//                 color: "#6b4a2e",
//                 marginBottom: "20px",
//                 opacity: 0.9,
//               }}
//             >
//               View this Shloka in detail
//             </p>

//             <motion.div
//               whileHover={{ scale: 1.07 }}
//               transition={{ duration: 0.2 }}
//             >
//               <Link
//                 to={`/verse/${verse.id}`}
//                 style={{
//                   display: "inline-block",
//                   fontSize: "1rem",
//                   color: "#fff",
//                   textDecoration: "none",
//                   background:
//                     "linear-gradient(90deg, #c97b2b, #ffb347, #ffd89b)",
//                   padding: "9px 22px",
//                   borderRadius: "50px",
//                   fontWeight: "600",
//                   boxShadow: "0 4px 12px rgba(249, 155, 50, 0.4)",
//                   transition: "all 0.3s ease",
//                 }}
//                 onMouseEnter={(e) => {
//                   e.currentTarget.style.boxShadow =
//                     "0 8px 20px rgba(255,180,80,0.6)";
//                   e.currentTarget.style.transform = "translateY(-3px)";
//                 }}
//                 onMouseLeave={(e) => {
//                   e.currentTarget.style.boxShadow =
//                     "0 4px 12px rgba(249,155,50,0.4)";
//                   e.currentTarget.style.transform = "translateY(0)";
//                 }}
//               >
//                 Open Shloka
//               </Link>
//             </motion.div>
//           </motion.div>
//         ))}
//       </div>

//       {/* 📱 Responsive tweaks */}
//       <style>
//         {`
//           @media (max-width: 992px) {
//             h2 { font-size: 2.2rem !important; }
//             p { font-size: 1.05rem !important; }
//           }

//           @media (max-width: 576px) {
//             h2 {
//               font-size: 1.7rem !important;
//               line-height: 1.4;
//             }
//             p { font-size: 0.95rem !important; }
//             div[style*="padding: 28px 20px"] {
//               padding: 22px !important;
//             }
//             div[style*="width: 45px"] {
//               width: 35px !important;
//               height: 35px !important;
//               font-size: 0.9rem !important;
//               top: -10px !important;
//               left: -10px !important;
//             }
//           }
//         `}
//       </style>
//     </motion.div>
//   );
// }

// export default Verses;




import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

function Verses() {
  const verses = Array.from({ length: 48 }, (_, i) => ({
    id: i + 1,
    title: `श्लोक ${i + 1}`,
    num: (i + 1).toLocaleString("hi-IN"),
  }));

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
      style={{
        background:
          "linear-gradient(180deg, #fff9ed 0%, #fff3df 35%, #fff 100%)",
        minHeight: "100vh",
        fontFamily: "'Poppins', 'Noto Sans Devanagari', sans-serif",
        color: "#4b2e05",
        padding: "70px 5%",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* 🌸 Radiant Mandala Glow */}
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          width: "600px",
          height: "600px",
          background:
            "radial-gradient(circle, rgba(255,210,140,0.25), transparent 70%)",
          transform: "translate(-50%, -50%)",
          filter: "blur(40px)",
          zIndex: 0,
        }}
      />

      {/* ✨ Floating Aura Particles */}
      {[...Array(15)].map((_, i) => (
        <motion.div
          key={i}
          initial={{
            opacity: Math.random() * 0.6 + 0.3,
            scale: Math.random() * 0.4 + 0.3,
          }}
          animate={{
            y: [0, -20, 0],
            opacity: [0.5, 0.8, 0.5],
          }}
          transition={{
            duration: 4 + Math.random() * 3,
            repeat: Infinity,
            delay: Math.random() * 2,
          }}
          style={{
            position: "absolute",
            top: `${Math.random() * 100}%`,
            left: `${Math.random() * 100}%`,
            width: "6px",
            height: "6px",
            background:
              "radial-gradient(circle, rgba(255,190,100,0.8), transparent 60%)",
            borderRadius: "50%",
            zIndex: 0,
          }}
        />
      ))}

      {/* 🕉️ Header */}
      <motion.div
        initial={{ y: -40, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8 }}
        style={{ textAlign: "center", marginBottom: "40px", position: "relative", zIndex: 1 }}
      >
        <h2
          style={{
            fontSize: "2.9rem",
            fontWeight: "800",
            background:
              "linear-gradient(90deg, #b67400, #e8a444, #ffe09a)",
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            color: "transparent",
            textShadow: "0 2px 15px rgba(255,220,160,0.4)",
          }}
        >
          Explore the 48 Shlokas of Bhaktamar Stotra
        </h2>

        <motion.div
          initial={{ scaleX: 0 }}
          animate={{ scaleX: 1 }}
          transition={{ duration: 1 }}
          style={{
            width: "180px",
            height: "4px",
            background:
              "linear-gradient(90deg, #b66b00, #ffb347, #ffd89b)",
            margin: "15px auto",
            borderRadius: "4px",
          }}
        />

        <p
          style={{
            fontSize: "1.15rem",
            color: "#5a3a0e",
            maxWidth: "780px",
            margin: "10px auto 0",
            lineHeight: "1.8",
          }}
        >
          Each Shloka radiates divine vibrations and deep meaning.
          Tap a verse below to open and contemplate its wisdom.
        </p>
      </motion.div>

      {/* 🪔 Verses Grid */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
          gap: "30px",
          paddingBottom: "100px",
          position: "relative",
          zIndex: 1,
        }}
      >
        {verses.map((verse, i) => (
          <motion.div
            key={verse.id}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.03 }}
            whileHover={{
              scale: 1.04,
              y: -4,
              boxShadow: "0 12px 25px rgba(255,190,120,0.4)",
            }}
            style={{
              background:
                "linear-gradient(145deg, #fffaf3, #fff1db, #ffe7c4)",
              borderRadius: "20px",
              padding: "30px 22px",
              border: "1px solid rgba(255,200,150,0.6)",
              textAlign: "center",
              boxShadow: "0 6px 15px rgba(0,0,0,0.08)",
              position: "relative",
              transition: "all 0.4s ease",
            }}
          >
            {/* 🔱 Shloka Number */}
            <motion.div
              initial={{ rotate: 0 }}
              whileHover={{ rotate: 360 }}
              transition={{ duration: 0.8 }}
              style={{
                position: "absolute",
                top: "-18px",
                left: "-18px",
                width: "52px",
                height: "52px",
                borderRadius: "50%",
                background:
                  "linear-gradient(135deg, #b66b00, #ffb347, #ffd89b)",
                color: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "700",
                fontSize: "1.1rem",
                boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
              }}
            >
              {verse.num}
            </motion.div>

            <h3
              style={{
                fontSize: "1.55rem",
                fontWeight: "700",
                color: "#7a4200",
                marginBottom: "10px",
                letterSpacing: "0.5px",
              }}
            >
              {verse.title}
            </h3>

            <p
              style={{
                fontSize: "1rem",
                color: "#6b4a2e",
                marginBottom: "25px",
                opacity: 0.85,
              }}
            >
              View this Shloka in detail
            </p>

            <motion.div whileHover={{ scale: 1.1 }} transition={{ duration: 0.25 }}>
              <Link
                to={`/verse/${verse.id}`}
                style={{
                  display: "inline-block",
                  background:
                    "linear-gradient(90deg, #c97b2b, #ffb347, #ffd89b)",
                  color: "#fff",
                  padding: "10px 24px",
                  borderRadius: "50px",
                  fontWeight: "600",
                  fontSize: "1rem",
                  boxShadow: "0 4px 12px rgba(249,155,50,0.4)",
                  textDecoration: "none",
                  transition: "all 0.3s ease",
                }}
              >
                Open Shloka
              </Link>
            </motion.div>
          </motion.div>
        ))}
      </div>

      {/* 📱 Responsiveness */}
      <style>
        {`
          @media (max-width: 992px) {
            h2 { font-size: 2.2rem !important; }
            p { font-size: 1.05rem !important; }
          }

          @media (max-width: 576px) {
            h2 { font-size: 1.7rem !important; line-height: 1.4; }
            p { font-size: 0.95rem !important; }
            div[style*="padding: 30px"] { padding: 22px !important; }
            div[style*="width: 52px"] {
              width: 38px !important; height: 38px !important;
              font-size: 0.9rem !important; top: -12px !important; left: -12px !important;
            }
          }
        `}
      </style>
    </motion.div>
  );
}

export default Verses;
